<template>
  <Modal
      v-model="_value"
      width="800"
      title="连续轨迹覆盖图"
      @on-visible-change="visibleChange"
      ok-text="关闭"
      cancel-text="">
    <Row>
      <Col span="4">车辆:{{gdDlysjgVehicleAnalyzeReport.registrationNum}}</Col>
      <Col span="4">终端:{{gdDlysjgVehicleAnalyzeReport.imei}}</Col>
      <Col span="4">总里程:{{gdDlysjgVehicleAnalyzeReport.allMileage / 10}}</Col>
      <Col span="4">连续里程:{{gdDlysjgVehicleAnalyzeReport.continuityMileage / 10}}</Col>
      <Col span="4">轨迹完整率:{{gdDlysjgVehicleAnalyzeReport.integralMaterial}}%</Col>
    </Row>
    <Row>
      <div style="height: 600px; width: 100%;">
        <!--<Button size="small" style="margin-bottom: 5px;" @click="onSwitch">切换显示</Button>-->
        <div style="width: 100%; height: 100%;" id="qqmap"></div>
        <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="mapLoadding">
          <Spin size="large"></Spin>
          <h6 style="color:#2d8cf0;margin-top:10px;">正在加载轨迹数据...</h6>
        </div>
      </div>
    </Row>
    <Row>
      <Table border highlight-row size="small" :columns="columns" :stripe="true" :data="discontinuousTracksList" ref="table">
      </Table>
    </Row>
    <Row>
      <Table border highlight-row size="small" :columns="shiftColumns" :stripe="true" :data="shiftTracksList" ref="table">
      </Table>
    </Row>
  </Modal>
</template>

<script>
import Vue from 'vue'
import store from '@/store'
import { GPS } from '@/libs/positonUtils'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { explainAlarmSign, explainState, explainDirection } from '@/libs/jt808util'

export default {
  name: 'gddlysjgcontinuoustracksviewmodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  components: {},
  data () {
    return {

      gdDlysjgVehicleAnalyzeReport: {
        id: null,
        vehicleInfo: {
          registrationNum: null
        },
        terminalNum: null,
        allMileage: 0,
        continuityMileage: 0,
        integralMaterial: 0
      },

      shiftTracksList: [],
      discontinuousTracksList: [],
      showDiscontinousPolyline: true,

      content: [],
      currentPageContent: [],
      pageSize: 30,
      vehicleInfoTableHeight: 200,

      mapData: {
        vehicleRunMarkerImage: null,
        vehicleStopMarkerImage: null,
        startMarker: null,
        endMarker: null,
        polyline: null,
        discontinuousTracksPolyline: [],
        shiftTracksPolyline: [],
        selectMarker: null,
        infoWin: null
      },

      // 地图
      qqMap: null,
      mapLoadding: false,
      mapDefaultCenter: null,
      // 行驶车辆
      vehicleMarkerAnchor: null,
      vehicleMarkerSize: null,
      vehicleMarkerOrigin: null,
      vehicleMarkerIcon: null,
      // 停止车辆图标
      vehicleStopMarkerAnchor: null,
      vehicleStopMarkerSize: null,
      vehicleStopMarkerOrigin: null,
      vehicleStopMarkerIcon: null,

      vehicleMarkers: [],

      dateFilter: [],
      startDate: null,
      endDate: null,

      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,
      terminalNum: null,
      columns: [
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          width: 110
        },
        {
          title: '开始时间',
          resizable: true,
          key: 'startDatetime',
          sortable: 'custom',
          width: 180,
          render: (h, params) => {
            if (params.row.startDatetime) {
              return h('div', new Date(params.row.startDatetime).Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '结束时间',
          resizable: true,
          key: 'endDatetime',
          sortable: 'custom',
          width: 180,
          render: (h, params) => {
            if (params.row.endDatetime) {
              return h('div', new Date(params.row.endDatetime).Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '里程',
          resizable: true,
          key: 'endDatetime',
          sortable: 'custom',
          width: 180,
          render: (h, params) => {
            if (params.row.mileage) {
              return h('div', params.row.mileage / 10)
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          fixed: 'right',
          minWidth: 90,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    if (this.mapData.discontinuousTracksPolyline) {
                      for (let i = 0; i < this.mapData.discontinuousTracksPolyline.length; i++) {
                        if (this.mapData.discontinuousTracksPolyline[i].trackId === params.row.id) {
                          if (this.mapData.discontinuousTracksPolyline[i].map == null) {
                            this.mapData.discontinuousTracksPolyline[i].setMap(this.qqMap)
                          } else {
                            this.mapData.discontinuousTracksPolyline[i].setMap(null)
                          }
                          break
                        }
                      }
                    }
                  }
                }
              }, '显示')
            ])
          }
        }
      ],
      shiftColumns: [
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          width: 110
        },
        {
          title: '开始时间',
          resizable: true,
          key: 'startDatetime',
          sortable: 'custom',
          width: 180,
          render: (h, params) => {
            if (params.row.startDatetime) {
              return h('div', new Date(params.row.startDatetime).Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '结束时间',
          resizable: true,
          key: 'endDatetime',
          sortable: 'custom',
          width: 180,
          render: (h, params) => {
            if (params.row.endDatetime) {
              return h('div', new Date(params.row.endDatetime).Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '里程',
          resizable: true,
          key: 'endDatetime',
          sortable: 'custom',
          width: 180,
          render: (h, params) => {
            if (params.row.mileage) {
              return h('div', params.row.mileage / 10)
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          fixed: 'right',
          minWidth: 90,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    if (this.mapData.shiftTracksPolyline) {
                      for (let i = 0; i < this.mapData.shiftTracksPolyline.length; i++) {
                        if (this.mapData.shiftTracksPolyline[i].trackId === params.row.id) {
                          if (this.mapData.shiftTracksPolyline[i].map == null) {
                            this.mapData.shiftTracksPolyline[i].setMap(this.qqMap)
                          } else {
                            this.mapData.shiftTracksPolyline[i].setMap(null)
                          }
                          break
                        }
                      }
                    }
                  }
                }
              }, '显示')
            ])
          }
        }
      ]

    }// return
  }, // data
  methods: {
    onSwitch () {
      if (this.showDiscontinousPolyline) {
        this.mapData.discontinuousTracksPolyline.forEach(item => {
          item.setMap(null)
        })
        this.showDiscontinousPolyline = false
      } else {
        this.mapData.discontinuousTracksPolyline.forEach(item => {
          item.setMap(this.qqMap)
        })
        this.showDiscontinousPolyline = true
      }
    },

    onRowClick (data, index) {
      if (!this.pageIndex) {
        this.pageIndex = 1
      }
      index = (this.pageIndex - 1) * 30 + index
      console.log('onRowClick:' + index)
      this.playControl.currentFrameIndex = index
      this.playControl.currentFrame = this.content[this.playControl.currentFrameIndex]
      let pos = GPS.gcj_encrypt(data.latitude, data.longitude)
      let p = new qq.maps.LatLng(pos.lat, pos.lon)
      this.mapData.selectMarker.setPosition(p)
      this.mapData.selectMarker.setMap(this.qqMap)
      this.mapData.selectMarker.setRotation(data.direction)
      if ((data.state & 0x01) === 0x01) {
        this.mapData.selectMarker.setIcon(this.mapData.vehicleRunMarkerImage)
      } else {
        this.mapData.selectMarker.setIcon(this.mapData.vehicleStopMarkerImage)
      }
      this.qqMap.setCenter(p)
      this.renderDisplay()
    },

    clearDraw () {
      if (this.mapData.startMarker) {
        this.mapData.startMarker.setMap(null)
        this.mapData.startMarker = null
      }
      if (this.mapData.endtMarker) {
        this.mapData.endtMarker.setMap(null)
        this.mapData.endtMarker = null
      }
      if (this.mapData.polyline) {
        this.mapData.polyline.setMap(null)
        this.mapData.polyline = null
      }
      if (this.mapData.selectMarker) {
        this.mapData.selectMarker.setMap(null)
        this.mapData.selectMarker = null
      }
      this.mapData.discontinuousTracksPolyline.forEach(item => {
        item.setMap(null)
      })
      this.mapData.discontinuousTracksPolyline = []
      this.mapData.shiftTracksPolyline.forEach(item => {
        item.setMap(null)
      })
      this.mapData.shiftTracksPolyline = []
    },

    drawTrack () {
      let startMarkerImage = new qq.maps.MarkerImage('/start.png', null, null, null, new qq.maps.Size(30, 40))
      let endMarkerImage = new qq.maps.MarkerImage('/end.png', null, null, null, new qq.maps.Size(30, 40))
      // if(!this.mapData.vehicleRunMarkerImage) {
      // this.mapData.vehicleRunMarkerImage = new qq.maps.MarkerImage('/vehiclerun.png', new qq.maps.Size(24, 43), new qq.maps.Point(0, 0), new qq.maps.Point(12, 21))
      // }
      // if(!this.mapData.vehicleStopMarkerImage) {
      // this.mapData.vehicleStopMarkerImage = new qq.maps.MarkerImage('/vehiclestop.png', new qq.maps.Size(24, 43), new qq.maps.Point(0, 0), new qq.maps.Point(12, 21))
      // }

      this.mapData.startMarker = new qq.maps.Marker({ icon: startMarkerImage })
      this.mapData.endtMarker = new qq.maps.Marker({ icon: endMarkerImage })
      // this.mapData.selectMarker = new qq.maps.Marker({icon: this.mapData.vehicleRunMarkerImage})

      let s = null
      let w = null
      let n = null
      let e = null
      let polylines = []
      let length = this.content.length
      let p = null
      for (var i = 0; i < length; i++) {
        if (i === 0) {
          let startPos = GPS.gcj_encrypt(this.content[i].lat, this.content[i].lng)
          this.mapData.startMarker.setPosition(new qq.maps.LatLng(startPos.lat, startPos.lon))
          this.mapData.startMarker.setMap(this.qqMap)

          let selectPos = GPS.gcj_encrypt(this.content[i].lat, this.content[i].lng)
          let p = new qq.maps.LatLng(selectPos.lat, selectPos.lon)
          // this.mapData.selectMarker.setPosition(p)
          // this.mapData.selectMarker.setMap(this.qqMap)
          // this.mapData.selectMarker.setRotation(this.content[i].direction)
          if ((this.content[i].state & 0x01) === 0x01) {
            // this.mapData.selectMarker.setIcon(this.mapData.vehicleRunMarkerImage)
          } else {
            // this.mapData.selectMarker.setIcon(this.mapData.vehicleStopMarkerImage)
          }
        }

        if (i === length - 1) {
          let endPos = GPS.gcj_encrypt(this.content[i].lat, this.content[i].lng)
          this.mapData.endtMarker.setPosition(new qq.maps.LatLng(endPos.lat, endPos.lon))
          this.mapData.endtMarker.setMap(this.qqMap)
        }

        if (n === null) {
          n = this.content[i].lat
        }
        if (s === null) {
          s = this.content[i].lat
        }
        if (w === null) {
          w = this.content[i].lng
        }
        if (e === null) {
          e = this.content[i].lng
        }

        if (this.content[i].lat < n) {
          n = this.content[i].lat
        }
        if (this.content[i].lat > s) {
          s = this.content[i].lat
        }
        if (this.content[i].lng < w) {
          w = this.content[i].lng
        }
        if (this.content[i].lng > e) {
          e = this.content[i].lng
        }
        if (i < length - 1) {
          // let pos = {lat:this.content[i].latitude, lon:this.content[i].longitude}
          let pos = GPS.gcj_encrypt(this.content[i].lat, this.content[i].lng)
          polylines.push(new qq.maps.LatLng(pos.lat, pos.lon))
          // p = new qq.maps.Polyline({path: [new qq.maps.LatLng(this.content[i].latitude, this.content[i].longitude), new qq.maps.LatLng(this.content[i + 1].latitude, this.content[i + 1].longitude)]})
          // p.setMap(this.qqMap)
          // polylines.push(p)
        }
      }
      this.mapData.polyline = new qq.maps.Polyline({ path: polylines })
      this.mapData.polyline.setMap(this.qqMap)
      // console.log(polylines)
      console.log('s:' + s + ',w:' + w + ',n:' + n + ',e:' + e)
      this.qqMap.fitBounds(new qq.maps.LatLngBounds(new qq.maps.LatLng(s, w), new qq.maps.LatLng(n, e)))
    },

    renderDisplay () {
      let d = new Date(this.playControl.currentFrame.locateDatetimeLongValue)
      this.playControl.display.locateDatetime = d.Format('yyyy年MM月dd日 hh:mm:ss')
      this.playControl.display.state = explainState(this.playControl.currentFrame.state)
      this.playControl.display.alarmSign = explainAlarmSign(this.playControl.currentFrame.alarmSign)
      this.playControl.display.speed = this.playControl.currentFrame.speed / 10
      this.playControl.display.mileage = this.playControl.currentFrame.mileage / 10
      this.playControl.display.direction = explainDirection(this.playControl.currentFrame.direction)
      this.playControl.display.longitude = this.playControl.currentFrame.longitude
      this.playControl.display.latitude = this.playControl.currentFrame.latitude
      d = new Date(this.playControl.currentFrame.recvDatetimeLongValue)
      this.playControl.display.recvDatetime = d.Format('yyyy年MM月dd日 hh:mm:ss')
      console.log(this.playControl.display)
    },

    onSliderChange (val) {
      console.log('onSliderChange')
      this.playControl.currentFrameIndex = val
      this.playControl.currentFrame = this.content[this.playControl.currentFrameIndex]
      this.onRowClick(this.playControl.currentFrame, this.playControl.currentFrameIndex)
    },

    mapInit () {
      this.mapDefaultCenter = new qq.maps.LatLng(39.916527, 116.397128)
      this.qqMap = new qq.maps.Map(document.getElementById('qqmap'), {
        // 地图的中心地理坐标。
        center: this.mapDefaultCenter
      })
    },

    visibleChange (val) {
      if (val) {
        this.clearDraw()
        store.dispatch('GdDlysjgVehicleAnalyzeReportServ_GetDetail', {
          params: { id: this._initValue },
          urlparams: null
        }).then(() => {
          let gdDlysjgVehicleAnalyzeReport = store.getters.get_GdDlysjgVehicleAnalyzeReport_GetDetailResult
          console.log(gdDlysjgVehicleAnalyzeReport)
          this.gdDlysjgVehicleAnalyzeReport = gdDlysjgVehicleAnalyzeReport
          let selectDatetime = new Date(gdDlysjgVehicleAnalyzeReport.analyzeDatetime)

          let startDate = (1900 + selectDatetime.getYear()) + '-' + (selectDatetime.getMonth() + 1) + '-' + selectDatetime.getDate() + ' 00:00:00'
          let endDate = (1900 + selectDatetime.getYear()) + '-' + (selectDatetime.getMonth() + 1) + '-' + selectDatetime.getDate() + ' 23:59:59'

          store.dispatch('GdDlysjgLocateHistoryServ_GetByLocationDatetime', {
            params: {
              registrationNum: gdDlysjgVehicleAnalyzeReport.registrationNum,
              startDatetime: startDate,
              endDatetime: endDate
            },
            urlparams: null
          }).then(() => {
            this.content = store.getters.get_GdDlysjgLocateHistory_GetByLocationDatetimeResult
            this.drawTrack()

            // 绘制断开轨迹
            this.discontinuousTracksList = []
            let discontinuousTracksList = gdDlysjgVehicleAnalyzeReport.discontinuousTracksList
            if (discontinuousTracksList) {
              discontinuousTracksList = JSON.parse(discontinuousTracksList)
              console.log(discontinuousTracksList)
              this.discontinuousTracksList = discontinuousTracksList.discontinuousTracksList
              discontinuousTracksList.discontinuousTracksList.forEach(item => {
                let polylinePath = []
                item.discontinuousTracks.forEach(p => {
                  let pos = GPS.gcj_encrypt(p.lat, p.lng)
                  polylinePath.push(new qq.maps.LatLng(pos.lat, pos.lon))
                })
                let polyline = new qq.maps.Polyline({ strokeColor: '#ff0000', path: polylinePath })
                polyline.setMap(this.qqMap)
                polyline.trackId = item.id
                this.mapData.discontinuousTracksPolyline.push(polyline)
              })
            }

            // 绘制漂移轨迹
            this.shiftTracksList = []
            let shiftTracksList = gdDlysjgVehicleAnalyzeReport.shiftTracksList
            if (shiftTracksList) {
              shiftTracksList = JSON.parse(shiftTracksList)
              console.log(shiftTracksList)
              this.shiftTracksList = shiftTracksList.shiftTracksList
              shiftTracksList.shiftTracksList.forEach(item => {
                let polylinePath = []
                item.shiftTracks.forEach(p => {
                  let pos = GPS.gcj_encrypt(p.lat, p.lng)
                  polylinePath.push(new qq.maps.LatLng(pos.lat, pos.lon))
                })
                let polyline = new qq.maps.Polyline({ strokeColor: '#CC00cc', path: polylinePath })
                polyline.setMap(this.qqMap)
                polyline.trackId = item.id
                this.mapData.shiftTracksPolyline.push(polyline)
              })
            }
          }).catch(err => {
            this.content = []
            this.$Message.error(err)
          })
        }).catch(err => {
          this.$Message.error(err)
        })
      }
    }
  },

  computed: {
    _value: {
      get () {
        return this.value
      },

      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },

    _initValue: {
      get () {
        return this.initValue
      },

      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },

  mounted () {
    this.$nextTick(() => {
      this.mapInit()
    })
  }
}
</script>

<style scoped>

</style>
